module.exports = __webpack_public_path__ + "img/aging_stock.1f742a66.svg";